import React from 'react'

import { useTranslation } from 'react-i18next'
import { EmptyUUID } from '@cbgms/base/utils/uuid'
import CheckIcon from '@mui/icons-material/Check'
import { Box } from '@mui/material'
import { IWholesalerCatalog } from '@cbgms/api'

export const CatalogDetails: React.FC<{ cat: IWholesalerCatalog }> = ({ cat }) => {
  const { t } = useTranslation()

  return (
    <>
      {cat.HbaseOverrideAPIKey && (
        <Box>
          {t('wholesaler-catalog.HbaseOverrideAPIKey')}: {cat.HbaseOverrideAPIKey}
        </Box>
      )}
      {cat.HbaseOverrideMGAppID && (
        <Box>
          {t('wholesaler-catalog.HbaseOverrideMGAppID')}: {cat.HbaseOverrideMGAppID}
        </Box>
      )}
      {cat.HbaseOverrideMGAppSecret && (
        <Box>
          {t('wholesaler-catalog.HbaseOverrideMGAppSecret')}: {cat.HbaseOverrideMGAppSecret}
        </Box>
      )}
      {cat.HbaseOverrideSupplierID && (
        <Box>
          {t('wholesaler-catalog.HbaseOverrideSupplierID')}: {cat.HbaseOverrideSupplierID}
        </Box>
      )}
      {cat.HbaseMapSurchargeFromCatalog && (
        <Box display='flex' alignContent='center'>
          {t('wholesaler-catalog.HbaseMapSurchargeFromCatalog')}: <CheckIcon />
        </Box>
      )}
      {cat.MDMOverrideApplicationID && (
        <Box>
          {t('wholesaler-catalog.MDMOverrideApplicationID')}: {cat.MDMOverrideApplicationID}
        </Box>
      )}
      {cat.MDMOverridePassword && (
        <Box>
          {t('wholesaler-catalog.MDMOverridePassword')}: {cat.MDMOverridePassword}
        </Box>
      )}

      {cat.MDMOverrideUsername && (
        <Box>
          {t('wholesaler-catalog.MDMOverrideUsername')}: {cat.MDMOverrideUsername}
        </Box>
      )}
      {cat.TecDocOverrideProvider && (
        <Box>
          {t('wholesaler-catalog.TecDocOverrideProvider')}: {cat.TecDocOverrideProvider}
        </Box>
      )}
      {cat.TecDocOverrideAPIKey && (
        <Box>
          {t('wholesaler-catalog.TecDocOverrideAPIKey')}: {cat.TecDocOverrideAPIKey}
        </Box>
      )}
      {cat.VPOMProductTreeID && (
        <Box>
          {t('wholesaler-catalog.VPOMProductTreeID')}: {cat.VPOMProductTreeID}
        </Box>
      )}
      {cat.VPOMDashboardCatalogUUIDS && cat.VPOMDashboardCatalogUUIDS.length > 0 && (
        <Box>
          {t('wholesaler-catalog.VPOMDashboardCatalogUUIDS')}:
          <ul style={{ margin: 0 }}>
            {cat.VPOMDashboardCatalogUUIDS.map((t, index) => (
              <li key={index}>{t.TreeUUID}</li>
            ))}
          </ul>
        </Box>
      )}
      {cat.RemoteIDOverride && (
        <Box>
          {t('wholesaler-catalog.RemoteIDOverride')}: {cat.RemoteIDOverride}
        </Box>
      )}
      {cat.CarsysProductTreeUUID && cat.CarsysProductTreeUUID !== EmptyUUID && (
        <Box>
          {t('wholesale.productgroup')}: {cat.CarsysProductTreeUUID}
        </Box>
      )}
      {cat.VPOMUseDevelopmentAPI && (
        <Box display='flex' alignContent='center'>
          {t('wholesaler-catalog.MDMUseDevelopAPI')}: <CheckIcon />
        </Box>
      )}
      {cat.VPOMHidePDHForNonTyres && (
        <Box display='flex' alignContent='center'>
          {t('wholesaler-catalog.VPOMHidePDHForNonTyres')}: <CheckIcon />
        </Box>
      )}
      {cat.QuickNavToProductGroupUUIDS && cat.QuickNavToProductGroupUUIDS.length > 0 && (
        <Box>
          {t('wholesaler-catalog.ProductGroupForCatalogUUID')}:
          <ul style={{ margin: 0 }}>
            {cat.QuickNavToProductGroupUUIDS.map((t, index) => (
              <li key={index}>{t.TreeUUID}</li>
            ))}
          </ul>
        </Box>
      )}
    </>
  )
}
